var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{attrs:{"rules":_vm.validationRules,"immediate":_vm.immediate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-text-field',_vm._g(_vm._b({attrs:{"error-messages":errors}},'v-text-field',[_vm.$attrs, _vm.$props],false),_vm.$listeners))]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }